import { Injectable } from '@angular/core';
import { AuthStatePersistenceService, EventService, WindowRef } from '@spartacus/core';
import { Ga4GgButtonClickEvent } from '../../events/analytics/ga4/general/ga4-gg-button-click.event';
import { Ga4GgAnchorClickEvent } from '../../events/analytics/ga4/general/ga4-gg-anchor-click.event';

@Injectable({
  providedIn: 'root',
})
export class ClickService {
  constructor(
    private eventService: EventService,
    private authStatePersistenceService: AuthStatePersistenceService,
    private winRef: WindowRef
  ) {}

  public dispatchGa4GgButtonClickEvent(buttonElement: HTMLButtonElement) {
    this.eventService.dispatch<Ga4GgButtonClickEvent>(
      {
        event: 'button',
        click_url: buttonElement.formAction,
        click_text: buttonElement.textContent !== null ? buttonElement.textContent : undefined,
        visitor_type: this.authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
      },
      Ga4GgButtonClickEvent
    );
  }

  public dispatchGa4GgAnchorClickEvent(anchorElement: HTMLAnchorElement) {
    this.eventService.dispatch<Ga4GgAnchorClickEvent>(
      {
        event: 'click',
        click_url: anchorElement.href,
        click_text: anchorElement.textContent !== null ? anchorElement.textContent : undefined,
        outbound: this.winRef.isBrowser() ? anchorElement.host !== this.winRef.location.host : undefined,
        visitor_type: this.authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
      },
      Ga4GgAnchorClickEvent
    );
  }
}
